<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Lista de Categorías</h1>
    <div class="results" v-if="categories">
      <div
        class="results__element"
        v-for="(category, index) in categories"
        :key="index"
      >
        <div class="results__info">
          <h2 class="results__title" v-text="category.title_es"></h2>
          <p
            v-if="category.sub_title_es"
            class="results__text"
            v-text="category.sub_title_es"
          ></p>
        </div>
        <div class="results__actions">
          <button
            @click.prevent="$parent.$emit('view', category.id)"
            class="btn btn__icon btn__icon--regular results__btn results__btn--view"
          >
            Ver Categoría
          </button>
          <button
            @click.prevent="$parent.$emit('edit', category.id)"
            class="btn btn__icon btn__icon--regular results__btn results__btn--edit"
          >
            Editar Categoría
          </button>
          <button
            @click.prevent="deleteCategory(category.id)"
            class="btn btn__icon btn__icon--regular results__btn results__btn--delete"
          >
            Borrar Categoría
          </button>
        </div>
      </div>
    </div>
    <div class="information" v-else>
      <p class="information__text">No se encontraron resultados</p>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from "@/core/api/request";
import confirmation from "@/components/layout/confirmation";
export default {
  props: {
    filters: {
      type: String,
      required: false,
      default: function() {
        return "";
      }
    }
  },
  mixins: [httpService],
  components: { confirmation },
  data: function() {
    return {
      categoryId: null,
      categories: null,
      confirm: false
    };
  },
  created: function() {
    this.getCategories();
  },
  mounted: function() {
    this.$on("continue", () => {
      this.confirm = false;
      this.proccedToDelete();
    });
  },
  watch: {
    filters: function() {
      this.getCategories();
    },
    "$store.state.elementChanged": function() {
      this.getCategories();
    }
  },
  methods: {
    getCategories: function() {
      let httpRequest = {
        params: "?" + this.filters,
        module: "product_categories"
      };
      this.get(httpRequest)
        .then(categories => {
          this.categories = categories.data;
        })
        .catch(() => {
          this.categories = null;
        });
    },
    deleteCategory: function(id) {
      this.confirm = true;
      this.categoryId = id;
    },
    proccedToDelete: function() {
      let httpRequest = {
        params: "",
        module: "product_categories"
      };
      this.delete(this.categoryId, httpRequest)
        .then(response => {
          this.getCategories();
          this.$store.commit("notificate", {
            title: "CATEGORÍA BORRADA",
            text: "La categoría ha sido borrada correctamente",
            type: "success"
          });
        })
        .catch(error => {
          this.$store.commit("notificate", {
            title: "CATEGORÍA NO BORRADA",
            text:
              "No se pudo borrar la categoría seleccionada, por favor intente más tarde",
            type: "warn"
          });
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/product_categories/list.vue